import rootReducer from "b2b/reducers";
import { configureStore as cs } from "2g-utils-redux";

export default function configureStore(initialState) {
  return cs(rootReducer, initialState);
}
